import * as JSZip from 'jszip';

export const CONVERSATIONAL_INTELLIGENCE = 'Conversational Intelligence';

export async function injectExcelMetadata(buffer: ArrayBuffer): Promise<ArrayBuffer> {
  const zip = await JSZip.loadAsync(buffer) as any;

  await injectCustomProperties(zip);
  await updateContentTypes(zip);
  await updateRelationships(zip);

  return zip.generateAsync({ type: 'arraybuffer', compression: 'DEFLATE' });
}

async function injectCustomProperties(zip: JSZip): Promise<void> {
  const xml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes">
  <property fmtid="{D5CDD505-2E9C-101B-9397-08002B2CF9AE}" pid="2" name="reportType">
    <vt:lpwstr>${CONVERSATIONAL_INTELLIGENCE}</vt:lpwstr>
  </property>
</Properties>`;
  zip.file('docProps/custom.xml', xml);
}

async function updateContentTypes(zip: JSZip): Promise<void> {
  const file = zip.file('[Content_Types].xml');
  if (!file) return;

  let content = await file.async('string');
  if (content.includes('custom-properties')) return;

  content = content.replace(
    '</Types>',
    '<Override PartName="/docProps/custom.xml" ContentType="application/vnd.openxmlformats-officedocument.custom-properties+xml"/></Types>'
  );
  zip.file('[Content_Types].xml', content);
}

async function updateRelationships(zip: JSZip): Promise<void> {
  const file = zip.file('_rels/.rels');
  if (!file) return;

  let content = await file.async('string');
  if (content.includes('custom-properties')) return;

  content = content.replace(
    '</Relationships>',
    '<Relationship Id="rId99" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties" Target="docProps/custom.xml"/></Relationships>'
  );
  zip.file('_rels/.rels', content);
}
